import styled from 'styled-components';
import { fontCondensed, fontDisplay, fontUi } from '../../../../theme/typography';

export const StyledStatsCard = styled.div`
  position: relative;
  overflow: hidden;
  background: transparent;
  border: 0;
  box-shadow: none;
  padding: 0;
  box-sizing: border-box;

  h1,
  h2,
  h3,
  h4 {
    display: none;
  }
`;

export const StyledStatTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledStatHead = styled.div`
  ${fontUi};
  display: grid;
  grid-template-columns: ${({ $withApp }) =>
    $withApp
      ? '28px minmax(0, 1fr) 40px 40px 40px 40px 48px'
      : '28px minmax(0, 1fr) 40px 40px 40px 48px'};
  gap: 8px;
  padding: 8px 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.textFaint};

  > span:first-child,
  > span:nth-child(n + 3) {
    text-align: center;
  }
`;

export const StyledStatRow = styled.button`
  ${fontUi};
  display: grid;
  grid-template-columns: ${({ $withApp }) =>
    $withApp
      ? '28px minmax(0, 1fr) 40px 40px 40px 40px 48px'
      : '28px minmax(0, 1fr) 40px 40px 40px 48px'};
  gap: 8px;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 10px 4px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.borderSubtle};
  background: transparent;
  font-size: 13px;
  color: ${({ theme }) => theme.text};
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.hover};
  }

  > span:first-child {
    color: ${({ theme }) => theme.textMuted};
    text-align: center;
  }
`;

export const StyledPlayer = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
  }

  strong {
    ${fontCondensed};
    font-weight: 400;
    letter-spacing: -0.02em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StyledStatPos = styled.span`
  ${fontUi};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-align: center;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledStatValue = styled.span`
  ${fontDisplay};
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  text-align: center;
`;

export const StyledEmpty = styled.p`
  ${fontUi};
  margin: 0;
  padding: 24px 8px;
  text-align: center;
  color: ${({ theme }) => theme.textFaint};
  font-size: 13px;
`;
